// extracted by mini-css-extract-plugin
module.exports = {"noProductsAvailable":"NoProducts_noProductsAvailable__9d9vh"};